module.exports = __webpack_public_path__ + "img/Joe Faust.e33164d7.jpg";